var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPalletExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-12c-3.033 0-5.5 2.467-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.467 5.5-5.5-2.467-5.5-5.5-5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5a.502.502 0 01-.312-.109l-2.5-2A.502.502 0 0117 18v-3.5a.5.5 0 011 0v3.26l2.312 1.85a.501.501 0 01-.312.89zM10.007 10.5a.5.5 0 01-.224-.947l9.494-4.75A.5.5 0 0120 5.25V9.5a.5.5 0 01-1 0V6.059l-8.77 4.388a.497.497 0 01-.223.053z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.493 20a.498.498 0 01-.243-.063l-8.994-5A.502.502 0 010 14.5V5.25a.5.5 0 01.723-.447l9.494 4.75a.5.5 0 01-.447.895L1 6.059v8.147l8.737 4.857a.5.5 0 01-.244.937z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5.75a.497.497 0 01-.223-.053L9.994 1.059.724 5.697a.5.5 0 11-.447-.894L9.771.053a.502.502 0 01.447 0l9.506 4.75a.5.5 0 01-.224.947z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.043 11.739a.5.5 0 01-.5-.5V7.521a.5.5 0 01.276-.447l9.494-4.75a.5.5 0 01.447.895L5.543 7.831v3.409a.499.499 0 01-.5.499z"
  })));
}

export default SvgPalletExpress;